// 📊 Vue d'ensemble V2 — valeur dont la source est indisponible : jamais « 0 $ », toujours « Indisponible » + raison.
import { AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function ValeurIndisponible({ raison = 'Source indisponible', action, lienAction, testid = 'valeur-indisponible', compact = false }) {
  const navigate = useNavigate();
  return (
    <span className={`inline-flex flex-col ${compact ? 'text-xs' : 'text-sm'}`} data-testid={testid} title={raison}>
      <span className="flex items-center gap-1 font-semibold text-amber-700"><AlertTriangle className="w-3.5 h-3.5" />Indisponible</span>
      <span className="text-[11px] text-slate-500" data-testid={`${testid}-raison`}>{raison}</span>
      {action && lienAction && (
        <button type="button" onClick={() => navigate(lienAction)} className="text-[11px] text-blue-700 underline text-left" data-testid={`${testid}-action`}>{action}</button>
      )}
    </span>
  );
}

export const QB_DECONNECTE = 'QuickBooks déconnecté';
